export default "__VITE_ASSET__COTE5bui__"